import {
  PROJECT_ROLES,
  PRODUCT_ROLES
} from 'containers/Role/constants'

const MODULE_NAME = 'fulcrum/container/Project/SupportTeam/MODULE_NAME'
const RESET_SUPPORT_TEAM = 'fulcrum/container/Project/SupportTeam/RESET_SUPPORT_TEAM'
const RESET_SUPPORT_TEAM_CHANGE = 'fulcrum/container/Project/SupportTeam/UPDATE_SUPPORT_TEAM'
const UPDATE_SUPPORT_TEAM = 'fulcrum/container/Project/SupportTeam/UPDATE_SUPPORT_TEAM'
const UPDATE_SUPPORT_TEAM_CHANGE = 'fulcrum/container/Project/SupportTeam/UPDATE_SUPPORT_TEAM_CHANGE'

const FETCH_SUPPORT_TEAM = 'fulcrum/container/Project/SupportTeam/FETCH_SUPPORT_TEAM'
const FETCH_SUPPORT_TEAM_START = 'fulcrum/container/Project/SupportTeam/FETCH_SUPPORT_TEAM_START'
const FETCH_SUPPORT_TEAM_SUCCESS = 'fulcrum/container/Project/SupportTeam/FETCH_SUPPORT_TEAM_SUCCESS'
const FETCH_SUPPORT_TEAM_ERROR = 'fulcrum/container/Project/SupportTeam/FETCH_SUPPORT_TEAM_ERROR'

const POST_SUPPORT_TEAM = 'fulcrum/container/Project/SupportTeam/POST_SUPPORT_TEAM'
const POST_SUPPORT_TEAM_START = 'fulcrum/container/Project/SupportTeam/POST_SUPPORT_TEAM_START'
const POST_SUPPORT_TEAM_SUCCESS = 'fulcrum/container/Project/SupportTeam/POST_SUPPORT_TEAM_SUCCESS'
const POST_SUPPORT_TEAM_ERROR = 'fulcrum/container/Project/SupportTeam/POST_SUPPORT_TEAM_ERROR'

const TEAM_ENUM = Object.freeze({
  ...PROJECT_ROLES,
  ...PRODUCT_ROLES
})

export {
  MODULE_NAME,
  TEAM_ENUM,
  RESET_SUPPORT_TEAM,
  RESET_SUPPORT_TEAM_CHANGE,
  UPDATE_SUPPORT_TEAM_CHANGE,
  UPDATE_SUPPORT_TEAM,
  FETCH_SUPPORT_TEAM,
  FETCH_SUPPORT_TEAM_START,
  FETCH_SUPPORT_TEAM_SUCCESS,
  FETCH_SUPPORT_TEAM_ERROR,
  POST_SUPPORT_TEAM,
  POST_SUPPORT_TEAM_START,
  POST_SUPPORT_TEAM_SUCCESS,
  POST_SUPPORT_TEAM_ERROR,
}
